import { BadgeProps } from '@silverfort/sf-components';

export const PROTECTED_ENTITY_BADGE_PROPS: BadgeProps = {
    text: 'Protected',
    color: 'positive'
};

export const UNPROTECTED_ENTITY_BADGE_PROPS: BadgeProps = {
    text: 'Unprotected',
    color: 'negative'
};
